module.exports = __webpack_public_path__ + "img/101 사회와법률-시험지-페이스북2.603b997a.png";